<div class="mx-auto max-w-(--breakpoint-2xl)">
@if (usersPage) {
  <app-data-table
    (route)="this.handleRoute($event)"
    [title]="'Contacts'"
    [dataPage]="usersPage"
    [columns]="tableColumns"
    [rowActions]="rowActions">
    <div header class="flex w-full flex-row items-center justify-end gap-3">
      <a routerLink="/contacts/create"
         class="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r bg-brand-600 hover:bg-brand-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105">
        <lucide-icon [name]="PlusIcon" size="18"></lucide-icon>
        Add Contact
      </a>
    </div>
  </app-data-table>
}
</div>
